export default __webpack_public_path__ + "static/logo-prestashop-b86a1090279d4943d11e0e97f6f4fb6d.svg";